import { isFeatureEnabled } from '@lumapps/features';
import { JOURNEYS_FF } from '@lumapps/journeys/constants';

export const isJourneysEnabled = isFeatureEnabled(JOURNEYS_FF);
